import iterateTimeline from "./iterate-timeline";
import onOffsetHooks from "./on-property-percents/on-offset-hooks";
import onStatusCycle from "./percents/on-status-cycle";

/**
 *
 * @param {TemporaryDataProps} data
 * @param {Boolean} enter
 * @param {Number} percents
 */
const onIntervalTimelineStatus = (data, percents, enter) => {
  const main = /** @type {MainClassProps} */ (data.get("main"));
  const trigger = /** @type {TriggerProps} */ (data.get("trigger"));
  const timeline = /** @type {TimelineMapProps} */ (data.get("timeline"));
  const overall = /** @type {Number} */ (timeline.get("percents-overall"));
  const iterations = /** @type {Number} */ (timeline.get("o_iterations"));

  if (enter) {
    /** Enter Started */
    if (overall === 0 || percents === 0) {
      /** Check timeline references */
      onStatusCycle(timeline, enter, "start", "started", 0);
    }

    /** Enter finished */
    if (overall === 1) {
      /** Run timeline repeat */
      iterateTimeline(trigger, timeline, main, enter, iterations);

      /** Check timeline references */
      onStatusCycle(timeline, enter, "finish", "finished", 0);
    }
  } else {
    /** Leave started */
    if (overall === 1 || percents === 0) {
      /** Check references */
      onStatusCycle(timeline, enter, "start", "started", 0);
    }

    /** Leave finished */
    if (overall === 0) {
      /** Run timeline repeat */
      iterateTimeline(trigger, timeline, main, enter, iterations);

      /** Check timeline references */
      onStatusCycle(timeline, enter, "finish", "finished", 0);
    }
  }

  /** Percentage hooks */
  if (timeline.get("has-offset-hook")) {
    onOffsetHooks(timeline, enter, overall, false);
  }
};

export default onIntervalTimelineStatus;
